import React from 'react';
import DailyDeviationIndicator from '@wix/da-ds/pkg/Indicators/DailyDeviationIndicator';
import deviationFlagStyles from './DeviationFlags.scss';
export var DeviationFlagBase = function (_a) {
    var innerRef = _a.innerRef, title = _a.title;
    return (React.createElement("div", { ref: innerRef, className: deviationFlagStyles['base'] },
        React.createElement(DailyDeviationIndicator, { size: "large", className: deviationFlagStyles['flag'] }),
        React.createElement("div", { className: deviationFlagStyles['collapsed-title'] }, title)));
};
DeviationFlagBase.displayName = 'DeviationFlagBase';
export default DeviationFlagBase;
//# sourceMappingURL=DeviationFlagBase.js.map